
(function() {
  
  angular.module('photometer-shopping-list-button', ['photometer-shoppinglist-service', 'photometer-filter-ofnumber', 'photometer-shopping-list-direcitve'])
      
    .controller('shopping-list-button', ['$scope', function($scope) { 
      //gähnende leere hier, wat?
    }])
      

}());